import React, {useEffect} from 'react';
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {translate} from "../../../../../components/translate/translate.jsx";

const TableContent = ({data, tableColumns}) => {
    const table = data?.table;
    const navigate = navigateHook();

    const {order, handleSort, sortedData, getIcon} = tableSortHeader(table ?? [], {action: (row) => translate(row.action)});

    const getDescription = (element) => {
        if (element.aggressor_id) {
            return <>Ação realizada para o agressor <strong>{element.aggressor_name ?? ""}</strong></>;
        }

        return element.description ?? "";
    };

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, 'Histórico operacional de SOS', 'sos-history-data');
    }, [table, tableColumns]);

    const columns = [
        {
            id: "dt_action",
            sortField: "dt_action",
            className: "w-[12%]",
            renderCell: (element) => element.dt_action ?? ""
        },
        {
            id: "citizen_name",
            sortField: "citizen_name",
            className: "w-[15%]",
            renderCell: (element) => (
                <a onClick={() => navigate(`/sos/citizens/form/${element.citizen_id}`, true)} className="inner-link" title="Acessar cadastro do protegido">
                    {element.citizen_name ?? ""}
                </a>
            )
        },
        {
            id: "action",
            sortField: "action",
            className: "w-[12%]",
            renderCell: (element) => element?.id ? (
                <a onClick={() => navigate(`/sos/event-history/${element.id}`, true)} className="inner-link" title="Acessar histórico de SOS">
                    {translate(element.action) ?? ""}
                </a>
            ) : translate(element.action)
        },
        {
            id: "description",
            sortField: "description",
            className: "w-[31%]",
            renderCell: getDescription
        },
        {
            id: "created_by",
            sortField: "created_by",
            className: "w-[15%]",
            renderCell: (element) => element.created_by ?? ""
        },
        {
            id: "responsible",
            sortField: "responsible",
            className: "w-[15%]",
            renderCell: (element) => element.responsible ?? ""
        }
    ];

    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length ? (
                <table id="sos-history-data" className="table report-table" sheet-name="Histórico operacional de SOS">
                    <thead className="thead-background print:table-row-group!">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column) => (
                                <th key={column.id} onClick={() => handleSort(column.sortField)} className={`${column.className} cursor-pointer`}>
                                    {tableColumns?.[column.id]?.label ?? column.id} {getIcon(order, column.sortField)}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {sortedData.map((element, index) => (
                            <tr key={index} className="table-break-word">
                                {visibleColumns.map((column) => (
                                    <td key={column.id} className={column.className}>
                                        {column.renderCell(element)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default TableContent;